import type { Npc, RoomDef } from '../defs.ts'
import { look } from '../town/kit.ts'

export const room: RoomDef = {
  id: 'hatshop',
  name: 'Hat Shop',
  blurb: 'Try anything on. The mirror is very honest.',
  w: 9, d: 8, outdoor: false, ground: 'carpet', accent: '#ff8fab',
  wall: { color: '#fbe9ef', trim: '#ff8fab' },
  zones: [[2, 2, 5, 4, 'tiles']],
  spawn: [3, 4],
  props: [
    { kind: 'rug', x: 2.4, y: 2.4, w: 4.2, d: 3.2, color: '#ff8fab' },
    { kind: 'hatstand', x: 1, y: 0, text: 'tophat' }, { kind: 'hatstand', x: 7, y: 0, text: 'crown' },
    { kind: 'hatstand', x: 8, y: 2, text: 'wizard' }, { kind: 'hatstand', x: 8, y: 4, text: 'cowboy' },
    { kind: 'hatstand', x: 8, y: 6, text: 'frog' }, { kind: 'hatstand', x: 3, y: 7, text: 'bunny' },
    { kind: 'hatstand', x: 5, y: 7, text: 'propeller' }, { kind: 'hatstand', x: 0, y: 1, text: 'party' },
    { kind: 'beanbag', x: 6, y: 5, color: '#ffd6e5', face: -1 },
    { kind: 'plant', x: 0, y: 7 }, { kind: 'lamp', x: 8, y: 7 },
  ],
  walls: [
    { kind: 'mirror', wall: 'back', at: 3.4, len: 2.2 },
    { kind: 'neon', wall: 'back', at: 6, len: 2.2, text: 'try me', color: '#ff8fab' },
    { kind: 'door', wall: 'left', at: 4, len: 1 },
    { kind: 'painting', wall: 'left', at: 1.6, len: 1.2, color: '#b69cff' },
  ],
  portals: [{ x: 0, y: 4, to: 'town', out: [1, 4], label: 'Outside' }],
  critters: [],
  places: [],
  spots: [{ x: 4, y: 1, action: 'wardrobe' }, { x: 5, y: 1, action: 'wardrobe' }],
  cap: 24, softCap: 18,
}

export const npcs: Npc[] = [
  {
    id: 'npc-felt', name: 'Madame Felt', role: 'Milliner', look: look('madamefelt', 6, 21, 0, 'flower'), speed: 1.1,
    stops: [
      { x: 2, y: 1, wait: 10, say: -1 },
      { x: 6, y: 1, wait: 10, emote: 'wink' },
      { x: 6, y: 3, wait: 8, say: -1 },
      { x: 2, y: 5, wait: 8, emote: 'happy' },
    ],
    lines: ['Stand by the mirror, darling, and try anything.', 'That hat was made for you.', 'Frogs are very in this season.', 'A crown? Bold. I love it.'],
  },
]
